import { Container } from '../Container';
import { Divider } from '../Divider';
import { Stack } from '../Stack';
import { DrawerFooterBaseStack, DrawerFooterElement, DrawerFooterPrimaryStack } from './style';
import { DrawerFooterProps } from './types';

export const DrawerFooter = ({ primary, secondary, responsive = true, divider = false }: DrawerFooterProps) => (
    <DrawerFooterElement>
        <Stack vertical>
            {divider ? <Divider /> : null}
            <Container padding={['200', '200', '0', '200']}>
                <Stack
                    spacing="150"
                    distribution="space-between"
                    itemAlignment="center"
                    largePhoneMax={{ vertical: responsive, distribution: 'space-between' }}
                >
                    {secondary ? (
                        <DrawerFooterBaseStack
                            alignment="start"
                            largePhoneMax={{ vertical: responsive, spacing: '150' }}
                            responsive={responsive}
                        >
                            {secondary}
                        </DrawerFooterBaseStack>
                    ) : null}
                    <DrawerFooterPrimaryStack
                        alignment="end"
                        largePhoneMax={{ vertical: responsive, spacing: '150' }}
                        responsive={responsive}
                    >
                        {primary}
                    </DrawerFooterPrimaryStack>
                </Stack>
            </Container>
        </Stack>
    </DrawerFooterElement>
);
